import { Box } from '@material-ui/core';
import { patchForgotPasswordCreateAndSendPasswordRecovery, User } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';

interface SendForgotPasswordEmailProps {
  selectedUser: User;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}

export const SendForgotPasswordEmail = ({
  selectedUser,
  opened,
  setOpened,
  handleClose,
}: SendForgotPasswordEmailProps) => {
  const { request, loading } = useRequest();
  const onSendRecoveryEmail = async () => {
    await request(patchForgotPasswordCreateAndSendPasswordRecovery, { username: selectedUser.username });
    handleClose();
  };

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={handleClose}>
            <Text tId="CANCEL" />
          </StandardButton>
          <StandardButton main loading={loading} onClick={() => onSendRecoveryEmail()}>
            <Text tId={'SEND_EMAIL'} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant="h3" color="textPrimary">
          <Text tId={'CHANGE_PASSWORD'} />
        </Font>
      </Box>
      <Box pt={3}>
        <Font variant={'body2'} color={'textSecondary'}>
          <Text
            tId={'FORGOT_PASSWORD_EMAIL_RECOVERY_WILL_BE_SEND_TO_USER'}
            dynamicDataTexts={[selectedUser.username]}
          />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
